import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-text 188",
  "use": "icon-text 188-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-text 188\"><path d=\"M725.333333 224V341.333333h-64v-53.333333h-181.333333V768H554.666667v64H341.333333v-64h74.666667V288h-192V341.333333h-64v-117.333333H725.333333zM853.333333 768v64H597.333333v-64h256z m0-128v64H597.333333v-64h256z m0-128v64H597.333333v-64h256z\" p-id=\"15647\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol